import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=8dfdcc00&scoped=true&"
import script from "./AccountView.vue?vue&type=script&lang=ts&"
export * from "./AccountView.vue?vue&type=script&lang=ts&"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=8dfdcc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfdcc00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VDivider,VRow,VSubheader})
